import React, { Children, cloneElement, forwardRef } from 'react';
import clsx from 'clsx';
import { Fieldset } from '../fieldset';
import { select as selectClass, fieldset as fieldsetClass } from './select.module.css';
export const Select = forwardRef(({ children, containerClassName, className, disabled = false, icon = 'arrow-simple-down/16', label, dimension = 'regular', kind = 'single', invalid, iconLeft, errorMessage, ...props }, forwardedRef) => {
    const filtredChildren = Children.toArray(children).filter(Boolean);
    const fieldsetProps = {
        invalid,
        iconLeft,
        label,
        disabled,
        icon: kind === 'single' ? icon : undefined,
        dimension,
        errorMessage,
        className: clsx(fieldsetClass, containerClassName)
    };
    const selectProps = {
        disabled,
        className: clsx(selectClass, className),
        multiple: kind === 'multiple'
    };
    return (React.createElement(Fieldset, { "data-select-multiple": kind === 'multiple', ...fieldsetProps },
        React.createElement("select", { ref: forwardedRef, ...selectProps, ...props }, Children.map(filtredChildren, (child) => cloneElement(child)))));
});
Select.displayName = 'Select';
